import React from "react";
import * as Icons from "lucide-react";
import { motion } from "framer-motion";
import { SectionHeading } from "./shared";
import { WHY, IMAGES } from "../data";

export const WhyUs = () => {
  return (
    <section className="relative bg-white py-20 lg:py-28">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          <div>
            <SectionHeading
              eyebrow="De ce AN CONTAB AUDIT"
              title="Motive să ne alegi ca partener financiar"
              subtitle="Combinăm rigoarea contabilă cu o abordare modernă, orientată spre creșterea afacerii tale."
            />

            <div className="mt-12 grid sm:grid-cols-2 gap-x-8 gap-y-8">
              {WHY.map((w, i) => {
                const Icon = Icons[w.icon] || Icons.Circle;
                return (
                  <motion.div
                    key={w.title}
                    data-testid={`why-card-${i}`}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-40px" }}
                    transition={{ duration: 0.5, delay: (i % 2) * 0.08 }}
                    className="group"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-brand-light text-brand group-hover:bg-brand group-hover:text-white transition-colors duration-300">
                      <Icon className="h-6 w-6" strokeWidth={1.75} />
                    </span>
                    <h3 className="mt-4 text-base font-semibold text-ink">{w.title}</h3>
                    <p className="mt-1.5 text-sm text-ink-muted leading-relaxed">{w.desc}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>

          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.7 }}
            className="relative lg:sticky lg:top-28"
          >
            <div className="rounded-[28px] overflow-hidden shadow-lift ring-1 ring-black/5">
              <img
                src={IMAGES.why}
                alt="Consultant financiar AN CONTAB AUDIT lucrând cu documente și grafice"
                className="w-full h-[420px] lg:h-[560px] object-cover"
                loading="lazy"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};
